module.exports = __webpack_public_path__ + "static/img/边5.118e2b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边5.png
// module id = wKbt
// module chunks = 2